import React, { useState, useEffect, useMemo } from 'react';
import { Widget, Table, Row, Col } from '@digital/ui';
import { DashboardData } from '../../api/dashboardContratos';
import moment from 'moment';
import { dateFormat } from '../../helpers/dateTimeFormats';
import '../Contrato/custom.css';
import { compareNumber, compareText, compareDates, compareCurrencyDecimal } from '@app/helpers/comparators';
import { Card } from 'antd';
import { currencyFormat } from '@app/helpers/numbers';

interface DadosTabela {
    dashboardData: DashboardData;
}

const DashboardContratoTabelaContratosVigentes = (props: DadosTabela) => {
    const { dashboardData } = props;
    const [data, setData] = useState({} as DashboardData);
    const [totalRegristros, setTotalRegistros] = useState<number>(0);

    const [totalContrato, setTotalContrato] = useState<any>(0);
    const [totalMedicao, setTotalMedicao] = useState<any>(0);
    const [totalSaldo, setTotalSaldo] = useState<any>(0);

    const AtualizarContados = useMemo(() => {
        if (data && data.topContratosVigentesAndAtivos) {
            setTotalRegistros(data.topContratosVigentesAndAtivos.length);
            let ContratoSoma: number = 0;
            let MedicaoSoma: number = 0;
            let SoldoSoma: number = 0;

            data.topContratosVigentesAndAtivos.map(item => {
                ContratoSoma += item.contrato;
            });


            data.topContratosVigentesAndAtivos.map(item => {
                MedicaoSoma += item.medido;
            });


            data.topContratosVigentesAndAtivos.map(item => {
                SoldoSoma += item.saldo;
            });


            setTotalContrato(currencyFormat(ContratoSoma));
            setTotalMedicao(currencyFormat(MedicaoSoma));
            setTotalSaldo(currencyFormat(SoldoSoma));
        }
    }, [data]);

    useEffect(() => {
        setData(dashboardData);
    }, [dashboardData, data]);

    const columnsTopContratos = [
        {
            title: 'Informações Contratuais',
            key: 'informacoesContratuais',
            children: [
                {
                    title: 'Contrato',
                    dataIndex: 'numeroContrato',
                    width: '3%',
                    sorter: (a, b) => compareNumberString(a.numeroContrato, b.numeroContrato),
                },
                {
                    title: 'Fornecedor',
                    dataIndex: 'fornecedor',
                    width: '14%',
                    sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
                },
                {
                    title: 'Valor',
                    key: 'valorHeader',
                    width: '20%',
                    children: [
                        {
                            title: 'Contrato',
                            dataIndex: 'contratoFormatado',
                            width: '5%',
                            sorter: (a, b) => compareCurrencyDecimal(a.contrato, b.contrato),
                        },
                        {
                            title: 'Medido',
                            dataIndex: 'medidoFormatado',
                            key: 'medidoValue',
                            width: '5%',
                            sorter: (a, b) => compareCurrencyDecimal(a.medido, b.medido),
                        },
                        {
                            title: 'Saldo',
                            dataIndex: 'saldoFormatado',
                            key: 'saldoValue',
                            width: '5%',
                            sorter: (a, b) => compareCurrencyDecimal(a.saldo, b.saldo),
                        },
                    ],
                },
                {
                    title: 'Vigência',
                    key: 'vigencia',
                    width: '10%',
                    children: [
                        {
                            title: 'Início',
                            dataIndex: 'inicio',
                            render: (text: string) => moment(text).format(dateFormat),
                            width: '5%',
                            sorter: (a, b) => compareDates(a.inicio, b.inicio),
                        },
                        {
                            title: 'Término',
                            dataIndex: 'termino',
                            render: (text: string) => moment(text).format(dateFormat),
                            width: '5%',
                            sorter: (a, b) => compareDates(a.termino, b.termino),
                        },
                        {
                            title: 'Dias Restantes',
                            dataIndex: 'diasRestantes',
                            width: '5%',
                            sorter: (a, b) => compareNumberString(a.diasRestantes, b.diasRestantes),
                        },
                    ],
                },
                {
                    title: 'QTD. Aditivo',
                    dataIndex: 'quantidadeAditivo',
                    width: '5%',
                    sorter: (a, b) => compareNumberString(a.quantidadeAditivo, b.quantidadeAditivo),
                },
                {
                    title: 'Área',
                    dataIndex: 'area',
                    key: 'areaValue',
                    width: '5%',
                    sorter: (a, b) => compareText(a.area, b.area),
                },
                {
                    title: 'Departamento',
                    dataIndex: 'departamento',
                    key: 'departamentoValue',
                    width: '5%',
                    sorter: (a, b) => compareText(a.departamento, b.departamento),
                },
                {
                    title: 'Gestor',
                    dataIndex: 'gestor',
                    width: '10%',
                    sorter: (a, b) => compareText(a.gestor, b.gestor),
                }
            ],
        },
    ];

    const divStyle = {
        fontWeight: 'bold',
        textAlign: 'right'
    };

    function getSum(total: number, num: number) {
        return total + Math.round(num);
    }

    function ComponentWithTransition() {
        return <div style={divStyle}>{`Total de Contratos: ${totalRegristros}`}</div>;
    }

    return (
        <Widget title="CONTRATOS ATIVOS">
            <div className="cards-contratos-ativos">
                <Row>
                    <Card title="Número de Contratos" bordered={false}>
                        {totalRegristros}
                    </Card>
                    <Card title="Valor Contratado" bordered={false}>
                        {totalContrato}
                    </Card>
                    <Card title="Valor Medido" bordered={false}>
                        {totalMedicao}
                    </Card>
                    <Card title="Valor de Saldo" bordered={false}>
                        {totalSaldo}
                    </Card>
                </Row>
            </div>
            <Table
                rowKey='numeroContrato'
                className="active-contracts-table"
                columns={columnsTopContratos}
                dataSource={data.topContratosVigentesAndAtivos}
                rowClassName={(record, index) => {
                    if (index == 0) return 'summary';
                    return '';
                }}
                footer={() => { return ComponentWithTransition(); }}
            />
        </Widget>
    );
};

export default DashboardContratoTabelaContratosVigentes;
